import React, { useState, useEffect } from 'react';
import RCalendar, { CalendarProps as RCalendarProps } from 'react-calendar';
import { CalendarWrapper } from './Calendar.styles';
import { Icon } from '../../Icon/Icon';

export interface CalendarProps extends RCalendarProps {
  isRange?: boolean;
}

export const Calendar: React.FC<CalendarProps> = ({ isRange = false, value, ...rest }) => {
  const [activeStartDate, setActiveStartDate] = useState(() => {
    if (value) {
      return isRange ? value[0] : value;
    }

    return new Date();
  });

  useEffect(() => {
    if (value) {
      setActiveStartDate(isRange ? value[0] : value);
    }
  }, [isRange, value]);

  const handleActiveStartDateChange = ({ activeStartDate: _activeStartDate }) => {
    setActiveStartDate(_activeStartDate);
  };

  return (
    <CalendarWrapper>
      <RCalendar
        calendarType="US"
        value={value}
        activeStartDate={activeStartDate}
        onActiveStartDateChange={handleActiveStartDateChange}
        selectRange={isRange}
        next2Label={null}
        prev2Label={null}
        prevLabel={<Icon className="fas fa-chevron-left" fontSize="h6" color="neutral.500" />}
        nextLabel={<Icon className="fas fa-chevron-right" fontSize="h6" color="neutral.500" />}
        {...rest}
      />
    </CalendarWrapper>
  );
};
